import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useEffect, useCallback, useRef } from 'react';
import { subscribe, SHOW_TOAST, CLEAR_TOAST } from '../../../../utils/eventBuser';
import { POSITION } from '../constants';
var getDefaultToasts = function getDefaultToasts() {
  return Object.entries(POSITION).reduce(function (obj, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    obj[value] = [];
    return obj;
  }, {});
};
export var useToastContainer = function useToastContainer(_ref3) {
  var position = _ref3.position,
    transition = _ref3.transition,
    autoClose = _ref3.autoClose,
    newestOnTop = _ref3.newestOnTop,
    useDefaultCloseButton = _ref3.useDefaultCloseButton,
    closeOnClick = _ref3.closeOnClick,
    containerId = _ref3.containerId;
  var _useState = useState(getDefaultToasts()),
    _useState2 = _slicedToArray(_useState, 2),
    toasts = _useState2[0],
    setToasts = _useState2[1];
  var toastNumberRef = useRef(1);
  var removeToast = useCallback(function (id) {
    var newToasts = Object.entries(toasts).reduce(function (obj, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];
      obj[key] = value.map(function (current) {
        if (current.id === id) current.isActive = false;
        return current;
      });
      return obj;
    }, {});
    setToasts(newToasts);
  }, [toasts]);
  var removeAllToast = useCallback(function () {
    var newToasts = Object.entries(toasts).reduce(function (obj, _ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        key = _ref7[0],
        value = _ref7[1];
      obj[key] = value.map(function (current) {
        current.isActive = false;
        return current;
      });
      return obj;
    }, {});
    setToasts(newToasts);
  }, [toasts]);
  var clearDeletedToast = useCallback(function (id) {
    var newToasts = Object.entries(toasts).reduce(function (obj, _ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
        key = _ref9[0],
        value = _ref9[1];
      obj[key] = value.filter(function (t) {
        return t.id !== id;
      });
      return obj;
    }, {});
    setToasts(newToasts);
  }, [toasts]);
  useEffect(function () {
    return subscribe(SHOW_TOAST, function (toast) {
      if (!toast) return;
      if (!containerId && toast.containerId || containerId && (toast === null || toast === void 0 ? void 0 : toast.containerId) !== containerId) return;
      toast.isActive = true;
      if (!toast.transition) toast.transition = transition;
      if (!toast.position) toast.position = position;
      if ((toast === null || toast === void 0 ? void 0 : toast.autoClose) === undefined || (toast === null || toast === void 0 ? void 0 : toast.autoClose) === null) {
        toast.autoClose = autoClose;
      }
      if ((toast === null || toast === void 0 ? void 0 : toast.useDefaultCloseButton) === undefined || (toast === null || toast === void 0 ? void 0 : toast.useDefaultCloseButton) === null) {
        toast.useDefaultCloseButton = useDefaultCloseButton;
      }
      if ((toast === null || toast === void 0 ? void 0 : toast.closeOnClick) === undefined || (toast === null || toast === void 0 ? void 0 : toast.closeOnClick) === null) {
        toast.closeOnClick = closeOnClick;
      }
      toast.number = toastNumberRef.current;
      toastNumberRef.current++;
      var toastPosition = (POSITION === null || POSITION === void 0 ? void 0 : POSITION[toast.position]) || null;
      if (!toastPosition) return;
      var toastsByPosition = _toConsumableArray(toasts[toastPosition]);
      if (newestOnTop) {
        toastsByPosition.push(toast);
      } else {
        toastsByPosition.unshift(toast);
      }
      var newToasts = _objectSpread(_objectSpread({}, toasts), {}, _defineProperty({}, toastPosition, toastsByPosition));
      setToasts(newToasts);
    });
  }, [toasts, containerId, position, newestOnTop, transition, autoClose, useDefaultCloseButton, closeOnClick]);
  useEffect(function () {
    return subscribe(CLEAR_TOAST, function (props) {
      if (!(props !== null && props !== void 0 && props.id)) return removeAllToast();
      removeToast(props.id);
    });
  });
  return {
    toasts: toasts,
    setToasts: setToasts,
    clearDeletedToast: clearDeletedToast,
    removeToast: removeToast
  };
};